










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ComponentsPartsCatalogCardComponentsElement extends Vue {
  // Props
  @Prop({ type: String, default: '' })
  title: string;

  @Prop({ type: Boolean, default: false })
  inline: false;

  @Prop({ type: Boolean, default: false })
  textAlignCenter: false;

  @Prop({ type: Boolean, default: false })
  inlineValuesElements: false;

  // computed
  get tag() {
    return this.inline ? 'span' : 'div';
  }

  get hasContent() {
    const { $slots } = this;
    return $slots.default && $slots.default.length > 0;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/card/components/sidebar/components/SidebarElement.vue